export const deleteRoutes = (builder) => ({
    deleteRoutes: builder.mutation({
        query: (body) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/delete_route',
                method: 'DELETE',
                body: body,
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
                },
              };
        },
    }),
});
